import { getCryptoCurrencyConfigForCryptoId } from '../../../services/utils'

import classes from './styles/cryptoPaymentDropdownItem.module.scss'

export const CryptoPaymentDropdownItem = ({ currency, hideCryptoName, selectedCryptoItem, onChange }) => {
  const cashierCurrency = getCryptoCurrencyConfigForCryptoId(currency.currencyCode)

  const cryptoFragment = (
    <>
      <img
        className={classes.cryptoPaymentDropdownItem__icon}
        src={`${process.env.PUBLIC_URL}/content/images/icons/crypto-icon-${currency.currencyCode.toLowerCase()}.png`}
        alt={currency.currencyName}
      />
      <span>
        {hideCryptoName ? currency.currencyCode : `${cashierCurrency?.currencyName} (${currency.currencyCode})`}
      </span>
    </>
  )

  return (
    <div
      className={classes.cryptoPaymentDropdownItem}
      onClick={() => {
        if (selectedCryptoItem.currencyCode !== currency.currencyCode) {
          onChange(currency)
        }
      }}
    >
      {cryptoFragment}
    </div>
  )
}
